import React, {Component} from 'react';

import {cityList} from "./cities/Cities";
import "./cities";
import Footer from "./Footer";
import Header from "./Header";
import './App.css';
import './css/camera.css';
import './css/stuck.css';
import './css/style.css';
import './css/touchTouch.css';

class App extends Component {
  render() {
    return (
        <div>
          <Header cities={cityList}/>
            {this.props.children}
          <Footer />
        </div>
    );
  }

  componentDidMount () {
    window.scrollTo(0, 0)
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js